enum AIVendor {
  StabilityAI = 'StabilityAI',
  OpenAI = 'OpenAIImages',
  ClipDrop = 'Clipdrop',
  Google = 'Google',
}

enum AIAction {
  Outpaint = 'ImageToImageMasking',
  RemoveBG = 'RemoveBackground',
  ReplaceBG = 'ReplaceBackground',
}

enum GenAIActionType {
  ImageToImageMasking,
  UpscaleImage, // Upscale
  ReplaceBackground,
  RemoveBackground, // Remove BG
  SketchToImage,
  TextToImage,
  ChatCompletion,
  GetEmbeddings,
  AudioTranscription,
  TextToSpeech,
  Outpainting, // Outpaint
  Inpaint, // Inpaing
  PromptToImage,
  ImageAnalysis,
  PromptToImageWithReferenceImages,
  ExtractTextLayers,
  ProxyResponseApi,
  EditByPrompt,
  ResourceSelection,
  AnswerGeneration,
  BoundingBoxDetection,
  ProductShot,
}

enum GenAIVendor {
  OpenAI, // Open AI as UI name
  StabilityAI, // Stability AI as UI name
  Clipdrop, // Clipdrop as UI name
  Anthropic, // Anthropic as UI name
  Runway, // Runway as UI name
  Google, // Google as UI name
  BriaAI, // Bria AI as UI name
}

export {AIVendor, AIAction, GenAIActionType, GenAIVendor};
